import { storyblokRoutesPaths } from "@/routes/storyblok"
import { useStoryblokBreadcrumb } from "../../../../hooks/useStoryblokBreadcrumb"
import { type SbFaqArticleStory } from "../../../../types"
import { StoryblokFAQArticle } from "../../../FAQArticle"

type FaqArticleTemplateProps = {
    story: SbFaqArticleStory
}

export function FaqArticleTemplate({ story }: FaqArticleTemplateProps) {
    const { title, blocks } = story.content
    // TODO is loading behavior
    const crumbs = useStoryblokBreadcrumb({
        story,
        root: { href: storyblokRoutesPaths.faq.resolve(), title: "FAQ" },
    })

    return (
        <StoryblokFAQArticle
            crumbs={crumbs}
            title={title}
            blocks={blocks}
        />
    )
}
